import core, { App, View } from '@gin-betting/core';
import { createStructuredSelector } from 'reselect';

import { useMemoSelector } from 'hooks';
import ui from 'modules/ui';
import { selectRouteBySportEvent } from 'selectors';
import { State } from 'types';

const {
    entities: {
        selectors: { selectMatch, selectMatchCompetitorsValid },
    },
} = core;

const {
    selectors: { selectOddsStatisticView },
} = ui;

interface Input {
    matchId: string;
}

interface Output {
    match: View.Match | null;
    competitors: View.CompetitorsValid;
    linkToMatch: string | null;
    isOddStatVisible: boolean;
}

const useMatchRow = ({ matchId }: Input): Output => {
    const {
        match,
        competitors,
        route,
        oddStatView,
    } = useMemoSelector((state: State) => selectProps(state, { matchId }));

    const linkToMatch = match
        ? `${route}${App.Routes.MATCH}${match.slug}`
        : null;

    return {
        match,
        competitors,
        linkToMatch,
        isOddStatVisible: oddStatView.show,
    };
};

export default useMatchRow;

const selectProps = createStructuredSelector({
    match: selectMatch,
    competitors: selectMatchCompetitorsValid,
    route: selectRouteBySportEvent,
    oddStatView: selectOddsStatisticView,
});
